"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MoneyService = /*#__PURE__*/function () {
  function MoneyService() {
    _classCallCheck(this, MoneyService);
  }
  _createClass(MoneyService, null, [{
    key: "explodeMoney",
    value: function explodeMoney(amount) {
      var sign = amount >= 0 ? "" : "-";
      var amtNum = Math.abs(amount);
      var amt = amtNum.toFixed(2).replace("$", "").split(".");
      var dollars = amt[0];
      var cents = amt.length > 1 && amt[1].length > 0 ? amt[1].substring(0, 2) : "00";
      if (cents.length === 1) {
        cents += "0";
      }
      return [sign, dollars, cents];
    }
  }, {
    key: "addCommas",
    value: function addCommas(amount) {
      return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
  }]);
  return MoneyService;
}();
var _default = MoneyService;
exports["default"] = _default;
//# sourceMappingURL=moneyService.js.map